<template>
  <v-layout row align-start justify-center>
    <v-card max-width="600">
        <v-toolbar color="primary" dark>
          <v-spacer/>
          <v-toolbar-title>
            <!--Welcome to Outfox AI-->
          </v-toolbar-title>
          <v-spacer/>
        </v-toolbar>

        <v-card-text class="pt-4">
          <v-flex>
            <h1 class="text-xs-center">Welcome to Outfox!</h1>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="primary" @click="next">Get Started</v-btn>
          <v-spacer/>
        </v-card-actions>
        <br>
      </v-card>
  </v-layout>
</template>

<script>
import helpers from '../../helpers/functions'
import lodash from 'lodash'
export default {
  name: 'WelcomeCongratsPage',
  created () {
    this.next()
  },
  methods: {
    next () {
      const advertiser = lodash.cloneDeep(helpers.getCurrentUser().selectedAdvertiser)
      advertiser.data.setupMode.status = false
      advertiser.data.setupMode.items[2].tasks[2].completed = true
      this.$store.dispatch('updateAdvertiser', advertiser)
      this.$store.dispatch('fetchApiData')
      this.$router.push('/setup-checklist')
    }
  }
}
</script>
